import request from "@/utils/http";

// 激活订单
export function orderActive(data) {
  return request.post("/promotion/order/active", data);
}

// 订单列表
export function orderList(listQuery) {
  return request
    .get(
      `/promotion/order/list?page=${listQuery.page}&size=${listQuery.size}&phone=${listQuery.phone}&activationStatus=${listQuery.status}&promotionId=${listQuery.promotionId}`
    )
    .then(res => res.result);
}

// 订单详情
export function orderInfo(orderNo) {
  return request
    .get(`/promotion/order/info/${orderNo}`)
    .then(res => res.result);
}

// 订单统计
export function statistics() {
  return request.get("/promotion/order/statistics").then(res => res.result);
}

// 核销
export function writeOff(code) {
  return request.post(`/coupon/writeOff?code=${code}`);
}
